import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  "https://ovjgsszavhawovemstyk.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im92amdzc3phdmhhd292ZW1zdHlrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMxMDEzNDYsImV4cCI6MjA2ODY3NzM0Nn0.y8DZnHXQ1nmKOXkrEepDa4eaNO_Gj7oc_JvPWA1YaSU"
)